import * as Sentry from "@sentry/react";

let initialized = false;

const getDsn = () => import.meta.env.VITE_SENTRY_DSN;

export const isErrorMonitoringEnabled = () => Boolean(getDsn());

export const initErrorMonitoring = () => {
  if (initialized || !getDsn()) {
    return;
  }

  const tracesSampleRate = Number(
    import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE ?? "0"
  );

  Sentry.init({
    dsn: getDsn(),
    enabled:
      import.meta.env.PROD ||
      import.meta.env.VITE_SENTRY_ENABLE_IN_DEV === "true",
    environment: import.meta.env.MODE,
    tracesSampleRate: Number.isFinite(tracesSampleRate)
      ? tracesSampleRate
      : 0,
  });

  initialized = true;
};

export const captureError = (
  error: unknown,
  context?: Record<string, unknown>
) => {
  if (!isErrorMonitoringEnabled()) {
    return;
  }

  if (error instanceof Error) {
    Sentry.captureException(error, { extra: context });
    return;
  }

  Sentry.captureMessage("Non-error exception captured", {
    level: "error",
    extra: {
      ...context,
      value: error,
    },
  });
};
